/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useQuery } from 'react-query';
import { getAccessTokenSafely } from '../../../../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';
import cartServiceClient from '../../../../../apis/cart-service-apis/cartServiceClient';

const useFoodDeliveryCalendar = (data) => {
    const {
        cartId,
        cartItemId,
        leadTimeEnterpriseCalendarEnabled,
        startDate,
    } = data;

    return useQuery(
        `foodEnterpriseCalendar-${startDate}`,
        async () => {
            const jwtToken = await getAccessTokenSafely();

            return cartServiceClient.displayCalendar({
                env: {},
                jwtToken,
                cartId,
                cartItemId,
                startDate,
            });
        },
        {
            retry: 1,
            staleTime: 1000 * Number(leadTimeEnterpriseCalendarEnabled) || 0, // Refresh the data in 30 min
            refetchOnWindowFocus: false,
            cacheTime: 1000 * Number(leadTimeEnterpriseCalendarEnabled) || 0, // Keep unused data in cache from the flag which-lead-time-enterprise-calendar-enabled
            refetchOnMount: false, // Don't refetch when component mounts if we have cached data
            refetchOnReconnect: false, // Don't refetch when reconnecting if we have cached data
        },
    );
};

export default useFoodDeliveryCalendar;
